module.exports = function() {
  return new Worker(__webpack_public_path__ + "9ee5da91f10ab7097baa.worker.js");
};